import { ActionColumn } from './action-column/action-column';
import { ActionMenuColumn } from './action-column/action-menu-column';
import { AvatarColumn } from './avatar-column/avatar-column';
import { CheckboxColumn } from './checkbox-column/checkbox-column';
import { DropdownColumn } from './dropdown-column/dropdown-column';
import { IconButtonColumn } from './icon-column/icon-button-column';
import { IconColumn } from './icon-column/icon-column';
import { PlainTextColumn } from './plain-text-column/plain-text-column';
import { PrimaryColumn } from './primary-column/primary-column';
import { TagColumn } from './tag-column/tag-column';
export var ObjecTableColumn;
(function (ObjecTableColumn) {
    ObjecTableColumn[ObjecTableColumn["checkbox"] = 0] = "checkbox";
    ObjecTableColumn[ObjecTableColumn["avatar"] = 1] = "avatar";
    ObjecTableColumn[ObjecTableColumn["primary"] = 2] = "primary";
    ObjecTableColumn[ObjecTableColumn["icon"] = 3] = "icon";
    ObjecTableColumn[ObjecTableColumn["iconButton"] = 4] = "iconButton";
    ObjecTableColumn[ObjecTableColumn["plainText"] = 5] = "plainText";
    ObjecTableColumn[ObjecTableColumn["tag"] = 6] = "tag";
    ObjecTableColumn[ObjecTableColumn["action"] = 7] = "action";
    ObjecTableColumn[ObjecTableColumn["actionMenu"] = 8] = "actionMenu";
    ObjecTableColumn[ObjecTableColumn["dropdown"] = 9] = "dropdown";
})(ObjecTableColumn || (ObjecTableColumn = {}));
export const OBJECT_TABLE_COLUMN = {
    checkbox: CheckboxColumn,
    avatar: AvatarColumn,
    icon: IconColumn,
    iconButton: IconButtonColumn,
    primary: PrimaryColumn,
    plainText: PlainTextColumn,
    tag: TagColumn,
    action: ActionColumn,
    actionMenu: ActionMenuColumn,
    dropdown: DropdownColumn,
};
//# sourceMappingURL=object-table-column.js.map